import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN}.${BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.REVENUE_PLAN}` as const;

export const REVENUE_PLAN_NAMES = {
  CURRENCY: 'currency',
  PLANNED_PRODUCTS_VOLUME: 'plannedProductsVolume',
  PLANNED_PRODUCTS_VOLUME_OTHER_INCOME: 'otherIncomePlannedProductsVolume',
  PLANNED_PRODUCTS_VOLUME_TOTAL: 'totalPlannedProductsVolume',
} as const;

export interface IRevenuePlan {
  [REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME]?: IPeriodsTableRow[];
  [REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_OTHER_INCOME]: IPeriodsTableRow[];
  [REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL]: IPeriodsTableRow;
}

export const revenuePlanInitialValues: IRevenuePlan = {
  [REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME]: [],
  [REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_OTHER_INCOME]: [initialPeriodsTableRow],
  [REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL]: initialPeriodsTableRow,
};
